import URLS from "@api/constants/urls";
import {
  handleGlobalDeleteRequest,
  handleGlobalPostRequest,
  handleGlobalPutRequest,
} from "@api/functions/changeRequests";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { URLSearchParamsInit } from "react-router-dom";
import {
  IVariantResponseSchema,
  IVariantSubmitSchema,
} from "./variantAPI.types";
import { IGlobalMetaSchema } from "@api/types/globalService.types";

const getAllVariantAPI = ({
  searchParams,
  signal,
}: {
  searchParams?: URLSearchParamsInit;
  signal?: AbortSignal;
}): Promise<{ data: IVariantResponseSchema[]; meta: IGlobalMetaSchema }> =>
  handleGlobalGetRequestQuery({ url: URLS.VARIANT, searchParams, signal });

const getSingleVariantAPI = (
  id: string
): Promise<{ data: IVariantResponseSchema }> =>
  handleGlobalGetRequestQuery({
    url: `${URLS.VARIANT}/${id}`,
  });

const createVariantAPI = (
  data: IVariantSubmitSchema
): Promise<{ data: IVariantResponseSchema }> =>
  handleGlobalPostRequest({ url: URLS.VARIANT, data });

const updateVariantAPI = (
  data: IVariantSubmitSchema
): Promise<{ data: IVariantResponseSchema }> =>
  handleGlobalPutRequest({ url: `${URLS.VARIANT}/${data.id}`, data });

const deleteVariantAPI = (id: number) =>
  handleGlobalDeleteRequest({ url: `${URLS.VARIANT}/${id}` });

export {
  getAllVariantAPI,
  getSingleVariantAPI,
  createVariantAPI,
  updateVariantAPI,
  deleteVariantAPI,
};
